export default "__VITE_PUBLIC_ASSET__d8c576f6__"